import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    title: "Your website is your hardest-working employee.",
    body: "It pitches while you sleep, answers objections before they are raised, and never asks for a raise. We build it to earn its keep.",
  },
  {
    n: "02",
    title: "Design is not decoration. It is direction.",
    body: "Every pixel either moves a visitor toward a decision or away from one. We are ruthless about the difference.",
  },
  {
    n: "03",
    title: "Clarity converts. Clutter costs.",
    body: "Slow, confusing websites quietly tax your business every single day. Speed and simplicity are not luxuries — they are margins.",
  },
  {
    n: "04",
    title: "We answer to one metric: your growth.",
    body: "Awards are nice. Revenue is nicer. Every engagement ends with numbers we are proud to put in front of you.",
  },
];

export const Manifesto = () => (
  <section id="studio" className="py-24 md:py-36" data-testid="manifesto-section">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-muted-foreground font-medium mb-4">
          Manifesto
        </p>
        <h2 className="font-syne font-bold tracking-tight text-4xl sm:text-5xl mb-16 md:mb-24">
          What we believe
        </h2>
      </Reveal>
      <div>
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 border-t border-border py-12 md:py-16 group"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="md:col-span-4">
                <span className="font-syne font-bold text-7xl md:text-8xl leading-none text-border group-hover:text-primary transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-8 md:text-right">
                <h3 className="font-syne font-semibold text-2xl sm:text-3xl tracking-tight mb-4">
                  {c.title}
                </h3>
                <p className="text-base md:text-lg text-muted-foreground font-light leading-relaxed md:ml-auto md:max-w-xl">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
